import { Field, TextAreaField, YesNoCards, OptionCards, CheckboxCards } from "@/components/controls";
import { EVENT_TYPES, TECH_COMFORT, FAMILIAR_TECH, TRAITS } from "@/lib/formConfig";

export default function StepExperience({ data, setField, toggleMulti }) {
  return (
    <div className="space-y-7">
      <div>
        <h2 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight text-slate-900">Experience</h2>
        <p className="text-sm sm:text-base text-slate-600 mt-1">Your event background, tech comfort, and what you bring to the team.</p>
      </div>

      <Field label="Have you worked events before?" required testId="field-worked-events">
        <YesNoCards name="worked-events" value={data.workedEvents} onChange={(v) => setField("workedEvents", v)} />
      </Field>

      <Field label="Event types" required hint="Check all that apply." testId="field-event-types">
        <CheckboxCards name="event-types" values={data.eventTypes} onToggle={(v) => toggleMulti("eventTypes", v)} options={EVENT_TYPES} />
      </Field>

      <Field label="Describe your experience" testId="field-describe-experience">
        <TextAreaField testId="input-describe-experience" value={data.describeExperience} onChange={(v) => setField("describeExperience", v)} placeholder="Tell us about events or roles you've worked…" />
      </Field>

      <Field label="Rate your comfort with technology" required testId="field-tech-comfort">
        <OptionCards name="tech-comfort" value={data.techComfort} onChange={(v) => setField("techComfort", v)} options={TECH_COMFORT} />
      </Field>

      <Field label="Check all you're familiar with:" required hint="Check all that apply." testId="field-familiar-tech">
        <CheckboxCards name="familiar-tech" values={data.familiarTech} onToggle={(v) => toggleMulti("familiarTech", v)} options={FAMILIAR_TECH} />
      </Field>

      <Field label="Tell us about you" required hint="What makes you a great fit for the CLiQ! vibe?" testId="field-about-you">
        <TextAreaField testId="input-about-you" value={data.aboutYou} onChange={(v) => setField("aboutYou", v)} placeholder="We want to hear it…" />
      </Field>

      <Field label="Professional traits" required hint="Check all that apply." testId="field-traits">
        <CheckboxCards name="traits" values={data.traits} onToggle={(v) => toggleMulti("traits", v)} options={TRAITS} />
      </Field>
    </div>
  );
}
